module.exports = __webpack_public_path__ + "monitoring-duty.svg?43800991f72be324494637408f65da11";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/monitoring-duty.svg
// module id = 296
// module chunks = 2